// src/components/ProtectedRoute.js
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext'; // ✅ Usa tu contexto

const ProtectedRoute = ({ children, allowedRoles }) => {
  const { userRole, loadingRole } = useAuth();
  const location = useLocation();

  console.log('[ProtectedRoute] userRole:', userRole);

  if (loadingRole) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 text-gray-600">
        Verificando permisos...
      </div>
    );
  }

  if (!userRole) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (!allowedRoles.includes(userRole)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

export default ProtectedRoute;
